import {useEffect, useRef, useState} from 'react';
import {AppState, AppStateStatus} from 'react-native';

import {useAppDispatch} from '../../redux';
import {netInfoSlice} from '../../redux/reducers/httpWrapper/netInfo';

export const useAppState = () => {
  const dispatch = useAppDispatch();
  const appState = useRef(AppState.currentState);
  const [appStateVisible, setAppStateVisible] = useState(appState.current);

  useEffect(() => {
    const subscription = AppState.addEventListener('change', _handleAppStateChange);

    return () => {
      subscription.remove();
    };
  }, []);

  const _handleAppStateChange = (nextAppState: AppStateStatus) => {
    // if (appState.current.match(/inactive|background/) && nextAppState === 'active') {
    //   console.log('App has come to the foreground!');
    // }
    if (nextAppState === 'background') {
      dispatch(netInfoSlice.actions.setError(false));
    }
    appState.current = nextAppState;
    setAppStateVisible(appState.current);
  };

  return appStateVisible;
};
